import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CreativeColorPicker } from './creative-color-picker';

export const CreativeColorEditor = ({
  colors,
  colorEditorId,
  setColorEditorId,
  updateSelectedColors,
  logger,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const onShowColorEditor = (id) => {
    setColorEditorId(id);
  };

  return (
    <div>
      <div style={{ display: 'flex', marginRight: '5px', marginTop: '10px' }}>
        {colors.map(color => (
          <div
            key={color.elementName}
            className={`creative-color-icon-container${colorEditorId === color.elementName ? ' selected-color' : ''
              }`}
          >
            {/* eslint jsx-a11y/click-events-have-key-events: 0 */}
            {/* eslint jsx-a11y/no-static-element-interactions: 0 */}
            <div
              onClick={() => onShowColorEditor(color.elementName)}
              className="creative-color-icon"
              style={{ backgroundColor: color.color }}
            />
          </div>
        ))}
      </div>
      {colors.map(color => (
        <div key={color.elementName}>
          {colorEditorId === color.elementName && (
            <CreativeColorPicker
              color={color}
              elementName={color.elementName}
              onShowColorEditor={onShowColorEditor}
              showColorPicker={showColorPicker}
              setShowColorPicker={setShowColorPicker}
              updateSelectedColors={updateSelectedColors}
              logger={logger}
            />
          )}
        </div>
      ))}
    </div>
  );
};

CreativeColorEditor.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({
    elementName: PropTypes.string,
    suffix: PropTypes.string,
    editable: PropTypes.bool,
    color: PropTypes.string,
  })).isRequired,
  colorEditorId: PropTypes.string,
  setColorEditorId: PropTypes.func.isRequired,
  updateSelectedColors: PropTypes.func.isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
};

CreativeColorEditor.defaultProps = {
  colorEditorId: '',
};
